import { showCartSuccessModal } from "./modules/cartSuccessModal.js";
import { ModalDialog } from "./modules/modalDialog.js";
import { fetchJson } from "./lib/fetchJson.js";
import { showCartErrorToast } from "./lib/toast.js";

interface MountConfig {
  label: string
  sku: string
  handle: string
}
const mounts: Record<string, MountConfig> = {
  "45220210180318": {
    label: "EF Mount",
    sku: "ember-s5k-ef-upgrade",
    handle: "ember-lens-mount-active-ef",
  },
  "48077690372318": {
    label: "L-Mount",
    sku: "ember-s5k-l-mount-upgrade",
    handle: "ember-lens-mount-active-l-mount",
  }
}

class EmberLensMountSerialModal extends ModalDialog {
  working = false;
  message?: HTMLElement
  form: HTMLElement | null
  serial: HTMLInputElement | null
  spinner: HTMLElement | null

  /** Shopify variant id from the `variant-id` attribute (set in Liquid). */
  get variantId(): string {
    return this.getAttribute('variant-id')?.trim() || '45220210180318'
  }

  get config(): MountConfig {
    return mounts[this.variantId] ?? mounts['45220210180318']
  }

  constructor() {
    super();
    this.form = this.querySelector("form")
    this.serial = this.querySelector("[name=serial]")
    this.spinner = this.querySelector(".ff-spinner")
    this.events()
  }

  hide() {
    super.hide();
  }

  show() {
    super.show(this);
    this.serial?.focus()
  }

  events(){
    super.events()
    this.form?.addEventListener("submit", this.formSubmit.bind(this) )
  }

  async formSubmit (e: SubmitEvent){
    e.preventDefault()
    this.spinner?.classList.remove("js-hide")

    const regex = /^E[0-9]{6}A?$/
    let serial = this.serial?.value
    if( !serial ){
      this.showMessage( "Error", `Serial number is required.`, "error")
      this.spinner?.classList.add("js-hide")
      return
    }
    serial = serial.toUpperCase()

    if( !serial.match(regex) ){
      this.showMessage( "Error", `Your serial number is not formatted correctly. Update it and try again.`, "error")
      this.spinner?.classList.add("js-hide")
      return
    }

    try{
      const data = await fetchJson<{ needsService?: boolean, message?: string }>( "https://csud6e1s27.execute-api.us-west-2.amazonaws.com/Prod/", {
        method: "POST",
        body: JSON.stringify({
          serial: this.serial?.value
        }),
      })
      if( data.needsService ){
        this.showMessage("Service is needed.", `Your Ember is on the list of those needing service at Freefly HQ. Follow <a href="https://freeflysystems.com/service-request?sku=${this.config.sku}">this link</a> to arrange for your upgrade.`, "success")
      }else if( data.needsService === false ){
        this.showMessage("Good news!", `Your Ember is on the list of those that can be upgraded at home. You can <a href="https://store.freeflysystems.com/cart?items=${this.variantId}:1" class="js-addLensMount">click here</a> to add ${this.config.label} to your shopping cart.`, "success")
      }else{
        this.showMessage( "Error", data.message + " Please try again or contact our <a href=\"mailto:support@freeflysystems.com\">support team</a> for assistance.", "error")
      }
    }catch(err: unknown){
      const message = err instanceof Error ? err.message : 'Something went wrong'
      this.showMessage( "Error", message, "error")
    }
    this.spinner?.classList.add("js-hide")
  }

  showMessage(hl: string, message: string, type: string){
    if( this.message ){
      this.form?.removeChild(this.message)
      this.message = undefined
    }
    const el = document.createElement("div")
    el.classList.add("row")
    el.innerHTML = `
<div class="message1 ${type}">
    <p class="messageHl"><strong>${ hl }</strong></p>
    <p>${message}</p>
</div>
    `
    const addLink = el.querySelector(".js-addLensMount")
    if( addLink ) addLink.addEventListener("click", this.addClick.bind(this) ) 
    this.form?.appendChild(el)
    this.message = el
  }

  addClick(e: Event){
    e.preventDefault()
    fetchJson(window.Shopify.routes.root + 'cart/add.js', {
      method: "POST",
      body: JSON.stringify({
        quantity: 1,
        id: this.variantId,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
    })
    .then(() => {
      this.hide()
      showCartSuccessModal(this.config.handle)
    })
    .catch(() => {
      showCartErrorToast()
    })
  }
}
customElements.define( 'ember-lens-mount-serial-modal', EmberLensMountSerialModal )


class FFEmberLensMount {
  constructor(){
    this.events()
  }

  events(){
    document.querySelector(".js-conversionLink")?.addEventListener("click", this.conversionClick.bind(this))
  }

  conversionClick(e: Event){
    e.preventDefault()
    const modal = document.querySelector("ember-lens-mount-serial-modal")
    if( modal instanceof EmberLensMountSerialModal ){
      modal.show()
    }
  }
}
new FFEmberLensMount()